import React from 'react';
import logo_seizo_s from "./images/svg/logo_seizo_s.svg";
import logo_seizo_nom from "./images/svg/logo_seizo_nom.svg";
import ModalPrimary from "./boiteAOutils/ModalPrimary";

const Mobile = () => {
    return (
        <ModalPrimary textComment={"Version mobile et tablette à venir."}>
            <div
                className={'mt-20 mb-20 w-full flex justify-center items-center text-center mx-auto'}>
                <img src={logo_seizo_s} alt="Logo SEIZO" className={"h-16 w-16 align-text-bottom"}/>
                <img src={logo_seizo_nom} alt="Logo SEIZO nom" className={"h-14"}/>
            </div>
        </ModalPrimary>
    );
};

export default Mobile;